import { render, staticRenderFns } from "./ExpressModadlWrap.vue?vue&type=template&id=71b404d6&"
import script from "./ExpressModadlWrap.vue?vue&type=script&lang=js&"
export * from "./ExpressModadlWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports